import getLocale from "./getLocale";

export function updateCertificateLinks(vue) {
    const targetLinks = document.getElementsByClassName("certificateLink");
    let clientCode;
    if(vue.$store.state.site==="cibc") {
    clientCode="CIBC"
    } else {
    clientCode="CIBCIndividual";
    }
    for(const targetLink in targetLinks) {
    if(isNaN(targetLink)===false) {
        const url = window.location.origin + "/" + getLocale(true)+"/api/certificate/"+clientCode+"/"+vue.$store.state.product.Product.ProductCode;
        targetLinks[targetLink].addEventListener("click",(event) => {
        openInNewWindow(url);
        });
    }
    };
}

function openInNewWindow(url, width, height) {
    const popupWidth = width == null ? 500 : width;
    const popupHeight = height == null ? 600 : height;
    const newWindow = window.open(
      url,
      "popup",
      "scrollbars=1,resizable=1,width=" +
        popupWidth +
        ",height=" +
        popupHeight
    );
  }